import dynamic from 'next/dynamic'

import { Loading } from '../../../../loading'

export const DynamicSellerModalContent = dynamic(
  async () => {
    return import('./SellerModalContent').then((mod) => mod.SellerModalContent)
  },
  {
    loading: () => <Loading />,
  },
)
